// ** Reducers Imports
import layout from './layout';
import navbar from './navbar';
import auth from './auth';
import { sanctionsApi } from '@features/sanctions/service';
import { usersApi, usersParams } from '@features/users/service';
import { sanctionsUsersWithMatchesParamsReducer } from '@features/sanctions/service';
import { transactionsApi, transactionsParamsReducer, ksbTransactionsParamsReducer } from '@features/transactions/service';
import { conversionsApi, conversionsParamsReducer } from '@features/conversions/service';
import { QRApplicationsApi, QRApplicationsParamsReducer } from '@features/qr-applications/service';
import { rolesApi } from '@features/roles/service';
import { liquidityApi } from '@features/liquidity/service';
import { saldoApi } from '@features/liquidity/service/saldo-api';
import { unstoppableLiquidityApi } from '@features/unstoppable-liquidity/service';
import { commissionsApi } from '@features/commissions/service';
import { limitsApi } from '@features/limits/service';
import { balanceApi } from '@features/balance/service';
import { notificationsApi } from '@features/notifications/service/notifications-api';
import { pushNotificationsApi, pushNotificationsParams } from '@features/push-notifications/service/push-notifications-api';
import { faqApi } from '@features/faq/service/faq-api';
import { newsApi } from '@features/news/service/news-api';
import { balanceReportApi } from '@features/balance-report/service';
import { balanceReportReducer } from '@features/balance-report/reducer';
import { adminLogsApi, adminLogsParamsReducer } from '@features/admin-logs/service';
import { discountRatesApi } from '@features/discount-rates/service/discount-rates-api';
import { referralCodeApi, referralCodeParamsReducer } from '@features/referral-code/service';
import { userSearchApi, userSearchParamsReducer } from '@features/user-search/service';
import { complianceApi, monthlyDepositsApi } from '@features/compliance/service';
import { depositAddressApi } from '@features/deposit-address/service';
import { transactionsCheckApi } from '@features/transactions-check/service';
import { systemLogsApi, systemLogsParamsReducer } from '@features/system-logs/service/system-logs-api';
import { fiatAssetsApi } from '@features/fiat-assets/service';
import { emailCampaignApi } from '@features/email-campaign/service';
import { marketingApi, marketingParamsReducer } from '@features/marketing/service';
import { quickSearchApi } from '@features/quick-search/service';
import { smsproApi } from '@features/smspro/service';
import { binanceBrokerApi } from '@features/binance-broker/service';
import { transferApi, subAccountTransferHistoryParams } from '@features/transfer/service';
import { usdtVolumeApi } from '@features/usdt-volume/service';
import { fiatVolumeApi } from '@features/fiat-volume/service';
import { onboardingApi } from '@features/onboarding/service';
import { questionareApi } from '@features/questionare/service/questionare-api';
import { deeplinksApi } from '@features/deeplinks/service';
import { misuseApi } from '@features/misuse/service';
import { blockLogApi, blockLogParamsReducer } from '@features/block-log/service';
import { cryptoAddressesApi } from '@features/crypto-addresses/service';

const rootReducer = {
  navbar,
  layout,
  auth,
  [sanctionsApi.reducerPath]: sanctionsApi.reducer,
  sanctionsUsersWithMatchesParams: sanctionsUsersWithMatchesParamsReducer,
  [liquidityApi.reducerPath]: liquidityApi.reducer,
  [saldoApi.reducerPath]: saldoApi.reducer,
  [unstoppableLiquidityApi.reducerPath]: unstoppableLiquidityApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  usersParams: usersParams.reducer,
  [transactionsApi.reducerPath]: transactionsApi.reducer,
  transactionsParams: transactionsParamsReducer,
  ksbTransactionsParams: ksbTransactionsParamsReducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [commissionsApi.reducerPath]: commissionsApi.reducer,
  [conversionsApi.reducerPath]: conversionsApi.reducer,
  conversionsParams: conversionsParamsReducer,
  [limitsApi.reducerPath]: limitsApi.reducer,
  [QRApplicationsApi.reducerPath]: QRApplicationsApi.reducer,
  QRApplicationsParams: QRApplicationsParamsReducer,
  [balanceApi.reducerPath]: balanceApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [pushNotificationsApi.reducerPath]: pushNotificationsApi.reducer,
  pushNotificationsParams: pushNotificationsParams.reducer,
  [faqApi.reducerPath]: faqApi.reducer,
  [newsApi.reducerPath]: newsApi.reducer,
  [balanceReportApi.reducerPath]: balanceReportApi.reducer,
  balanceReport: balanceReportReducer,
  [adminLogsApi.reducerPath]: adminLogsApi.reducer,
  adminLogsParams: adminLogsParamsReducer,
  [discountRatesApi.reducerPath]: discountRatesApi.reducer,
  [referralCodeApi.reducerPath]: referralCodeApi.reducer,
  referralCodeParams: referralCodeParamsReducer,
  [userSearchApi.reducerPath]: userSearchApi.reducer,
  userSearchParams: userSearchParamsReducer,
  [complianceApi.reducerPath]: complianceApi.reducer,
  [monthlyDepositsApi.reducerPath]: monthlyDepositsApi.reducer,
  [depositAddressApi.reducerPath]: depositAddressApi.reducer,
  [transactionsCheckApi.reducerPath]: transactionsCheckApi.reducer,
  [systemLogsApi.reducerPath]: systemLogsApi.reducer,
  systemLogsParams: systemLogsParamsReducer,
  [fiatAssetsApi.reducerPath]: fiatAssetsApi.reducer,
  [emailCampaignApi.reducerPath]: emailCampaignApi.reducer,
  [marketingApi.reducerPath]: marketingApi.reducer,
  marketingParams: marketingParamsReducer,
  [quickSearchApi.reducerPath]: quickSearchApi.reducer,
  [smsproApi.reducerPath]: smsproApi.reducer,
  [binanceBrokerApi.reducerPath]: binanceBrokerApi.reducer,
  [transferApi.reducerPath]: transferApi.reducer,
  [subAccountTransferHistoryParams.name]: subAccountTransferHistoryParams.reducer,
  [usdtVolumeApi.reducerPath]: usdtVolumeApi.reducer,
  [fiatVolumeApi.reducerPath]: fiatVolumeApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  [questionareApi.reducerPath]: questionareApi.reducer,
  [deeplinksApi.reducerPath]: deeplinksApi.reducer,
  [misuseApi.reducerPath]: misuseApi.reducer,
  [blockLogApi.reducerPath]: blockLogApi.reducer,
  blockLogParams: blockLogParamsReducer,
  [cryptoAddressesApi.reducerPath]: cryptoAddressesApi.reducer,
};

export default rootReducer;
